import { render, staticRenderFns } from "./FormulationGeneral.vue?vue&type=template&id=56b3bb81&"
import script from "./FormulationGeneral.vue?vue&type=script&lang=js&"
export * from "./FormulationGeneral.vue?vue&type=script&lang=js&"
import style0 from "./FormulationGeneral.vue?vue&type=style&index=0&id=56b3bb81&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports